import service from '../../../../../services';
import messagingApi from '@/services/messaging.api';

/**
 * Limpa o(s) campo(s) 'template*' do formulário
 * @param {object} form Objeto do formulário
 * @param {string} canal Canal do template
 * @returns objeto do formulário
 */
export const clearTemplate = (form, canal = null) => {
  if (!canal) {
    form.templateWhatsapp = null;
    form.templateSms = null;
    form.templateEmail = null;
    form.assuntoEmail = null;
  } else if (canal === 'Email') {
    form[`template${canal}`] = null;
    form.assuntoEmail = null;
  } else {
    form[`template${canal}`] = null;
  }

  return form;
};

/**
 * Recupera a lista de varíaveis do assunto
 * @param {array} assuntos Array de assuntos
 * @param {number} findIdMensageriaAssuntoMensagem Id do Assunto
 * @returns lista de variaveis
 */
export const getAvailableVariables = (
  assuntos,
  findIdMensageriaAssuntoMensagem,
) => {
  const result = assuntos.find((x) => x.id === findIdMensageriaAssuntoMensagem);
  if (result) {
    return JSON.parse(result.variables);
  }

  return null;
};

/**
 * Recupera a listagem de assuntos
 * @returns {array} lista de assuntos
 */
export const getAssuntos = async () => {
  try {
    const result = await messagingApi.getSubjects();
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Recupera a mensagem pelo id
 * @param {number} idMensageria id da mensagem
 * @returns {object}
 */
export const getMensagem = async (idMensageria) => {
  try {
    const result = await service.getAll(
      'mensageria',
      {},
      `mensagem/${idMensageria}`,
    );
    return Promise.resolve(result.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Cria a mensagem
 * @param {body} body dados da mensagem
 * @returns {object}
 */
export const postMensagem = async (body) => {
  try {
    const result = await service.post('mensageria', 'mensagem', body);
    return Promise.resolve(result.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Atualiza a mensagem
 * @param {number} idMensagem id da mensagem
 * @param {object} body dados da mensagem
 * @returns {object}
 */
export const putMensagem = async (idMensagem, body) => {
  try {
    const result = await service.put(
      'mensageria',
      `mensagem/${idMensagem}`,
      body,
    );
    return Promise.resolve(result.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
